export const AdSetCreatedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M15.5 5.5L21.5 5.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M18.5 2.5L18.5 8.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <mask id="path-5-inside-1_5868_51513" fill="white">
            <rect x="0.333984" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-5-inside-1_5868_51513)"
        />
        <mask id="path-6-inside-2_5868_51513" fill="white">
            <rect x="7.74023" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-6-inside-2_5868_51513)"
        />
        <mask id="path-7-inside-3_5868_51513" fill="white">
            <rect x="7.74023" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-7-inside-3_5868_51513)"
        />
        <mask id="path-8-inside-4_5868_51513" fill="white">
            <rect x="0.333984" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-8-inside-4_5868_51513)"
        />
    </svg>
)

export default AdSetCreatedIcon
